/**
 * Supabase Realtime Subscriptions for AMETAL PCS
 * Subscribes to key tables and notifies the app of changes.
 */
import { supabase, isSupabaseEnabled } from "./supabase";

// Tables to subscribe to for realtime updates
const REALTIME_TABLES = [
  "projects",
  "purchase_orders",
  "po_line_items",
  "vendor_invoices",
  "vendor_payments",
  "warehouse_transactions",
  "daily_logs",
  "boq_items",
  "todos",
  "notifications",
  "equipment",
  "items",
  "vendors",
];

let channel = null;

/**
 * Subscribe to realtime changes on key tables.
 * @param {function} onDataChange - callback(tableName, eventType, record)
 *   tableName: Supabase table name (e.g. "purchase_orders")
 *   eventType: "INSERT" | "UPDATE" | "DELETE"
 *   record: the new/updated/old record
 * @returns {object|null} the channel, or null if Supabase is not enabled
 */
export function subscribeToChanges(onDataChange) {
  if (!isSupabaseEnabled) return null;

  // Clean up any existing subscription
  unsubscribeAll();

  channel = supabase.channel("ametal-realtime");

  REALTIME_TABLES.forEach((tableName) => {
    channel.on(
      "postgres_changes",
      { event: "*", schema: "public", table: tableName },
      (payload) => {
        const eventType = payload.eventType; // INSERT, UPDATE, DELETE
        const record = eventType === "DELETE" ? payload.old : payload.new;
        onDataChange(tableName, eventType, record);
      }
    );
  });

  channel.subscribe((status) => {
    if (status === "SUBSCRIBED") {
      console.log("Supabase realtime: subscribed to", REALTIME_TABLES.length, "tables");
    }
    if (status === "CHANNEL_ERROR") {
      console.warn("Supabase realtime: channel error");
    }
  });

  return channel;
}

/**
 * Unsubscribe from all realtime subscriptions and clean up.
 */
export function unsubscribeAll() {
  if (!isSupabaseEnabled) return;
  if (channel) {
    supabase.removeChannel(channel);
    channel = null;
  }
}
